import { CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from './chunk-PNP5GBN2.js';
import { useTheme } from './chunk-EOFYHHEG.js';
import { Toaster as Toaster$1 } from 'sonner';
export { toast } from 'sonner';
import { jsx, jsxs } from 'react/jsx-runtime';
import * as React2 from 'react';
import { ShortcutManager } from '@authe/fe-commons/shortcuts';

function Toaster(props) {
  let resolvedMode = "light";
  try {
    resolvedMode = useTheme().resolvedMode;
  } catch {
  }
  return /* @__PURE__ */ jsx(
    Toaster$1,
    {
      theme: resolvedMode,
      className: "toaster group",
      toastOptions: {
        classNames: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-brand group-[.toast]:text-brand-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          error: "group-[.toaster]:border-destructive/40"
        }
      },
      ...props
    }
  );
}
function CommandMenu({
  groups,
  open: controlledOpen,
  onOpenChange,
  placeholder = "Type a command or search\u2026",
  emptyMessage = "No results found.",
  toggleCombo = "mod+k"
}) {
  const [internalOpen, setInternalOpen] = React2.useState(false);
  const open = controlledOpen ?? internalOpen;
  const setOpen = React2.useCallback(
    (next) => {
      if (controlledOpen == null) setInternalOpen(next);
      onOpenChange?.(next);
    },
    [controlledOpen, onOpenChange]
  );
  React2.useEffect(() => {
    const manager = new ShortcutManager();
    manager.register({
      combo: toggleCombo,
      description: "Open command menu",
      allowInInput: true,
      handler: () => setOpen(!open)
    });
    return manager.attach();
  }, [open, setOpen, toggleCombo]);
  return /* @__PURE__ */ jsxs(CommandDialog, { open, onOpenChange: setOpen, children: [
    /* @__PURE__ */ jsx(CommandInput, { placeholder }),
    /* @__PURE__ */ jsxs(CommandList, { children: [
      /* @__PURE__ */ jsx(CommandEmpty, { children: emptyMessage }),
      groups.map((group, i) => /* @__PURE__ */ jsx(CommandGroup, { heading: group.heading, children: group.actions.map((action) => /* @__PURE__ */ jsxs(
        CommandItem,
        {
          value: [action.label, ...action.keywords ?? []].join(" "),
          disabled: action.disabled,
          onSelect: () => {
            setOpen(false);
            action.onSelect();
          },
          children: [
            action.icon,
            /* @__PURE__ */ jsx("span", { children: action.label }),
            action.shortcut && /* @__PURE__ */ jsx("span", { className: "ml-auto text-xs tracking-widest text-muted-foreground", children: action.shortcut })
          ]
        },
        action.id
      )) }, group.heading ?? `group-${i}`))
    ] })
  ] });
}
var listeners = /* @__PURE__ */ new Set();
function notifyDisplayPrefs() {
  for (const listener of [...listeners]) listener();
}
function useDisplayPref(read, write) {
  const [value, setValue] = React2.useState(read);
  const readRef = React2.useRef(read);
  readRef.current = read;
  const writeRef = React2.useRef(write);
  writeRef.current = write;
  React2.useEffect(() => {
    const listener = () => setValue(readRef.current());
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);
  const set = React2.useCallback((next) => {
    setValue(next);
    if (writeRef.current(next)) notifyDisplayPrefs();
  }, []);
  return [value, set];
}

export { CommandMenu, Toaster, useDisplayPref };
//# sourceMappingURL=chunk-2WAYXCCV.js.map
//# sourceMappingURL=chunk-2WAYXCCV.js.map